import styled from 'styled-components'

export const StyledButton = styled.button`
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  border: solid #0003 1px;
  cursor: pointer;
  height: 40px;
  position: relative;
  transition: background-color 0.3s;
  width: 40px;
`

export const StyledImg = styled.img`
  cursor: all-scroll;
  max-height: 600px;
  max-width: 100%;
  object-fit: cover;
`

export const StyledWrapImage = styled.div`
  cursor: all-scroll;
`

export const StyledRightButtons = styled.div`
  display: grid;
  overflow: hidden;
  position: absolute;
  right: 2rem;
  top: 2rem;
  z-index: 2;
`

export const StyledSliderDiv = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  height: 2.5rem;
  left: 2rem;
  padding: 0 0.5rem;
  position: absolute;
  top: 2rem;
  width: 8rem;
`
